import makeBem from "Utils/makeBem";

import "../bem-css";

export const bem = makeBem("ZeroRuby");
